import _ from 'lodash';
import 'bootstrap';
window._ = _;
